export default function isEventAboutToStart({ startTime, timeInMinutes }) {
  const currTime = new Date().getTime();
  const eventStartTime = new Date(startTime).getTime();
  return eventStartTime - currTime <= timeInMinutes * 60 * 1000;
}
